module.exports = __webpack_public_path__ + "img/gls_gbt5782_2000.prt.d5e02d22.jpg";